import { Theme } from '@theme'
import { StyleSheet } from 'react-native'

export default (theme: Theme) =>
  StyleSheet.create({
    container: {
      flex: 1,
      width: '100%',
      justifyContent: 'space-between',
    },
    buttonContainer: {
      flex: 1,
      alignItems: 'center',
      justifyContent: 'flex-end',
      paddingBottom: theme.spacing.md,
    },
    emailInput: {
      paddingTop: theme.spacing.xxxl,
      marginBottom: theme.spacing.sm,
    },
    forgotPassowrd: {
      alignSelf: 'flex-end',
      paddingTop: theme.spacing.md,
      paddingBottom: theme.spacing.md,
    },
    noAccount: {
      paddingTop: theme.spacing.lg,
      marginBottom: theme.spacing.xxxl, 
    },
  })
